/* eslint-disable @typescript-eslint/no-explicit-any */
import axiosInstance from "../../utility/axios";

// state
import openNotification from "../../modules/toasts/index";
import {
  setUpdate,
  // setServiceRequestLoading,
  setServiceRequest,
  setRequestStatus,
  setServiceRequests,
  setLoading,
  setTotal,
  setBarGraph,
  createRequestPrice as createRequestPriceState,
  updateRequestPrice as updateRequestPriceState,
  deleteRequestPrice as deleteRequestPriceState,
} from "../../store/slices/request";
// import { save_document } from "./upload";
import { AppDispatch } from "../../store/store";
import { isAxiosError } from "axios";
import {
  ICreateRequestPrice,
  IPrice,
  IUploadDocument,
  IUpdateRequestPrice,
} from "../../store/types/request";
import { toast } from "sonner";

export const get_service_requests = async (
  dispatch: AppDispatch,
  current_page: number,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get(
      `v1/get-requests?page=${current_page}`,
    );

    dispatch(setServiceRequests(response.data?.data));
  } catch (err) {
    if (isAxiosError(err)) {
      openNotification({
        type: "error",
        title: "Incorrect Credentials",
        description: err?.response?.data.message,
      });
    }
  }
  dispatch(setLoading());
};

export const get_request = async (dispatch: AppDispatch, id: string) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get(`/v1/get-request/${id}`);

    const { data } = response.data;
    dispatch(setServiceRequest(data));
  } catch (err) {
    if (isAxiosError(err)) {
      // console.log(err.response?.data);
    }
  }
  dispatch(setLoading());
};

export const createServiceRequest = async (
  formData: any,
  dispatch: AppDispatch,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post("/create-service", formData);
    if (response.data) {
      openNotification({
        type: "success",
        title: "Successful!",
        description: response.data.message,
      });
    }
    setTimeout(() => {
      window.location.reload();
    }, 500);
  } catch (err) {
    if (isAxiosError(err)) {
      openNotification({
        type: "error",
        title: "Incorrect Credentials",
        description: err.response?.data.message,
      });
    }
  }
  dispatch(setLoading());
};

export const editServiceRequest = async (data: any, dispatch: AppDispatch) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.put(`/edit-training`, data);
    if (response.data) {
      openNotification({
        type: "success",
        title: "Successful!",
        description: response.data.message,
      });
    }
    setTimeout(() => {
      window.location.reload();
    }, 500);
  } catch (err) {
    if (isAxiosError(err)) {
      openNotification({
        type: "error",
        title: "Incorrect Credentials",
        description: err?.response?.data.message,
      });
    }
  }
  dispatch(setLoading());
};

export const cancel_request = async (dispatch: AppDispatch) => {
  try {
    const response = await axiosInstance.patch("/update-status");

    // dispatch(setRequest(response.data));
    console.log(response.data);
  } catch (err) {
    if (isAxiosError(err)) {
      console.log(err?.response?.data);
    }
  }
};

export const upload_document = async (
  dispatch: AppDispatch,
  data: IUploadDocument,
) => {
  dispatch(setUpdate());
  try {
    const response = await axiosInstance.post(
      "v1/create-document-service-request",
      data,
    );

    toast.success(response?.data?.message);
  } catch (err) {
    if (isAxiosError(err)) toast.error(err?.response?.data?.message);
  }
  dispatch(setUpdate());
};

export const get_total = async (dispatch: AppDispatch) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get("/v1/get-total-request");

    const { data } = response.data;
    dispatch(setTotal(data));
  } catch (error) {
    if (isAxiosError(error)) console.log(error?.response?.data);
  }
  dispatch(setLoading());
};

export const get_all_request_histogram = async (dispatch: AppDispatch) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get("/v1/get-all-request-chart");

    const { data } = response.data;
    dispatch(setBarGraph(data));
  } catch (error) {
    if (isAxiosError(error)) console.log("Error:", error?.response?.data);
  }
  dispatch(setLoading());
};

export const get_statuses = async (dispatch: AppDispatch) => {
  try {
    const response = await axiosInstance.get("/v1/request-statuses");

    const { data } = response;
    dispatch(setRequestStatus(data));
  } catch (err) {
    if (isAxiosError(err)) return false;
  }
};

//service price request.

export const addRequestPrice = async (
  dispatch: AppDispatch,
  data: ICreateRequestPrice,
) => {
  dispatch(setUpdate());
  try {
    const response = await axiosInstance.post("v1/create-request-price", data);
    const { message, data: payload } = response.data;

    dispatch(createRequestPriceState(payload as IPrice));

    toast.success(message);
  } catch (err) {
    if (isAxiosError(err)) {
      toast.error(err?.response?.data?.message || "Unable to create price.");
    }
  }
  dispatch(setUpdate());
};

export const updateRequestPrice = async (
  dispatch: AppDispatch,
  data: IUpdateRequestPrice,
) => {
  dispatch(setUpdate());
  try {
    const response = await axiosInstance.patch("v1/update-request-price", data);
    const { message, data: payload } = response.data;

    dispatch(updateRequestPriceState(payload));

    toast.success(message);
  } catch (err) {
    if (isAxiosError(err)) {
      toast.error(err?.response?.data?.message || "Unable to update price.");
    }
  }
  dispatch(setUpdate());
};

export const deleteRequestPrice = async (
  dispatch: AppDispatch,
  request_id: string,
) => {
  dispatch(setUpdate());
  try {
    const response = await axiosInstance.delete("v1/delete-request-price", {
      data: { request_id },
    });
    const { message } = response.data;

    dispatch(deleteRequestPriceState(request_id));

    toast.success(message);
  } catch (err) {
    if (isAxiosError(err)) {
      toast.error(err?.response?.data?.message || "Unable to delete price.");
    }
  }
  dispatch(setUpdate());
};
